import React from 'react';
import { useParams } from 'react-router-dom';

import { getTranslation } from 'helpers/getTranslation';
import { getLessonUploadRequestParams } from 'helpers/lessonAssetPaths.helpers';

import { Typography } from 'components/shared/Typography';

import { FormikField } from 'components/FormikField';
import {
  UploadField,
  SwitchField,
  EditableTextField,
} from 'components/FormikFields';

import styles from './DifferenceItem.module.scss';

const DifferenceItem = ({
  readOnly,
  namePrefix,
}: {
  readOnly: any;
  namePrefix: any;
}) => {
  const { courseId, lessonId } = useParams();

  return (
  <div className={styles.item}>
    <FormikField
      name={`${namePrefix}.url`}
      withControl={false}
      component={UploadField}
      componentProps={{
        readOnly,
        className: styles.image,
        variant: 'quizImage',
        ...getLessonUploadRequestParams({
          courseId,
          lessonId: lessonId as string,
        }),
      }}
    />
    <div className={styles.correct}>
      <Typography className={styles.correctText} variant="body3" mode="compact">
        {getTranslation('difference_lesson_page.difference_item.correct')}
      </Typography>
      <FormikField
        name={`${namePrefix}.correct`}
        withControl={false}
        component={SwitchField}
        componentProps={{ readOnly, type: 'checkbox' }}
      />
    </div>
    <FormikField
      name={`${namePrefix}.text`}
      withControl={false}
      component={EditableTextField}
      componentProps={{
        readOnly,
        className: styles.text,
        multiline: true,
        variant: 'text',
        placeholder: getTranslation(
          'difference_lesson_page.difference_item.placeholder',
        ),
      }}
    />
  </div>
  );
};

export default React.memo(DifferenceItem) as any;
